import {Observable} from 'rxjs/Observable';

export abstract class AuthorizationService <T> { // class-interface https://angular.io/guide/dependency-injection-in-action#class-interface
  abstract login(username: string, password: string, identifier?: string ): Observable<T>;
  abstract logout(): Promise<any> | void;
  abstract isAuthenticated(): Promise<boolean> | boolean;
  abstract getUserLogged(): Promise<T|undefined>;
  abstract getUserLogged$(): Observable<T|undefined>;
  abstract refresh(): Observable<any>;
  abstract getAuthHeader?(): string;
  // abstract isLogged(): boolean;
  // abstract getLoggedUser(): Promise<T>;
}




// WEBPACK FOOTER //
// ./src/app/shared/authorization/generic/authorization.ts